import React, { useContext, useState, useEffect } from 'react'
import Proptypes from 'prop-types'
import {
  Button,
  Modal,
  Form,
  FormField,
  Dropdown,
  Header,
  Icon,
  Segment,
} from 'semantic-ui-react'
import * as yup from 'yup'
import { useSelector, useDispatch } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'
import Swal from 'sweetalert2'
import { useForm } from 'react-hook-form'
import { primaryColor } from '../../../../constants'
import { CustomerViewContext } from '../customer-info-view/customerView'
import { setCustomerData } from '../../../../redux/actions/facility'
import { getHierarchy, addHierarchy } from '../../../../services/customer'
import { GetUserCustomers } from '../../../../services/asset/index'
import './customerHierarchy.module.css'

let tenantId = ''
let product = ''
const specialChar = /^[A-Za-z0-9ء-ي ]+$/

const formValidator = {
  name: yup
    .string()
    .trim()
    .required('Name Is Required')
    .matches(specialChar, 'Name has invalid characters'),
  level1: yup.string().required('You must select a Level 1'),
  Latitude: yup.number().required('Latitude is required'),
  Longitude: yup.number().required('Longitude is required'),
}
const tankFormValidator = {
  name: yup
    .string()
    .trim()
    .required('Name Is Required')
    .matches(specialChar, 'Name has invalid characters'),
  level1: yup.string().required('You must select a Level 1'),
}

const AddRegionModal = (props) => {
  const dispatch = useDispatch()
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  const [customersList, setCustomersList] = useState([])
  const [selectedCustomer, setSelectedCustomer] = useState()

  if (userEmail) {
    const products = JSON.parse(localStorage.getItem('products'))
    product = localStorage.getItem('product')
    // eslint-disable-next-line prefer-destructuring
    tenantId = products.filter((p) => p.productName === product)[0]
  }
  const [open, setOpen] = useState(false)
  const { customerSettings } = useContext(CustomerViewContext)
  const [zones, setZones] = useState([])

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(
      yup
        .object()
        .shape(product === 'cold' ? formValidator : tankFormValidator),
    ),
  })
  console.log('err: ', errors)
  useEffect(() => {
    const customerData = []
    GetUserCustomers(userEmail, product).then((customers) => {
      customers.forEach((customer) => {
        customerData.push({
          text: customer.title,
          value: customer.tbCustomerId,
        })
      })
      setCustomersList(customerData)
    })
  }, [])
  useEffect(() => {
    setOpen(props.open)
    if (product !== 'cold') {
      ;(async () => {
        if (props.open) {
          const queryParams = {
            customerId: customerSettings.tbCustomerId,
            type: product === 'cold' ? 'country' : 'zone',
            product,
          }
          Swal.showLoading()
          const res = await getHierarchy(queryParams)
          console.log(res)
          if (!res.success) Swal.fire('Error Garbing Level 1', '', 'error')
          else {
            Swal.close()
            setZones(res.data)
          }
        }
      })()
    }
  }, [props.open])
  useEffect(() => {
    if (selectedCustomer) {
      ;(async () => {
        if (props.open) {
          const queryParams = {
            customerId: selectedCustomer,
            type: product === 'cold' ? 'country' : 'zone',
            product,
          }
          Swal.showLoading()
          const res = await getHierarchy(queryParams)
          console.log(res)
          if (!res.success) Swal.fire('Error Garbing Level 1', '', 'error')
          else {
            Swal.close()
            setZones(res.data)
          }
        }
      })()
    }
  }, [selectedCustomer])

  useEffect(() => {
    props.getOpenState('region', open)
  }, [open])

  const addRegion = async (data) => {
    console.log('region data', data)
    if (data.name.trim() === '') return
    let body = {}
    if (product === 'cold') {
      body = {
        name: data.name,
        type: 'region',
        tenantId: tenantId.tenantId,
        searchText: data.name,
        customerId: selectedCustomer,
        latitude: data.Latitude,
        longitude: data.Longitude,
      }
    } else {
      body = {
        name: `${customerSettings.title}_${data.name}`,
        type: 'region',
        tenantId: tenantId.tenantId,
        label: data.name,
        searchText: data.name,
        customerId: customerSettings.tbCustomerId,
      }
    }

    console.log('data zone: ', data)
    const queryParams = {
      product,
      fromId: data.level1,
      fromType: product === 'cold' ? 'country' : 'zone',
    }
    console.log(body)
    console.log(queryParams)
    if (product === 'cold') {
      queryParams.lat = data.Latitude
      queryParams.lng = data.Longitude
    }
    const res = await addHierarchy(queryParams, body)
    console.log(res)
    if (res.success) {
      await Swal.fire({
        title: 'Level 2 Added Successfully',
        icon: 'success',
        confirmButtonColor: 'Green',
      })
      setOpen(false)
    } else {
      Swal.fire(res.msg || 'Error adding level 2', '', 'error')
    }
  }
  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <Modal.Header>Add Level 2</Modal.Header>
        <Modal.Content>
          {!selectedCustomer && product === 'cold' ? (
            <Segment placeholder>
              <Header icon>
                <Icon name="address card" />
                Please Select Customer
              </Header>

              <Dropdown
                name="customers"
                options={customersList}
                placeholder="Select Customer to Create New Level"
                defaultValue={selectedCustomer}
                fluid
                search
                selection
                onChange={async (e, data) => {
                  console.log('e.target.value', data.value)
                  setSelectedCustomer(data.value)
                  dispatch(setCustomerData(data.value))
                }}
              ></Dropdown>
            </Segment>
          ) : null}
          {selectedCustomer && product === 'cold' ? (
            <Form
              style={{
                padding: 10,
                borderRadius: 9,
              }}
              onSubmit={handleSubmit(addRegion)}
              id="cold"
            >
              <FormField>
                <span>* Level 1 (Top Level):</span>
                <select name="level1" ref={register}>
                  <option disabled selected>
                    {' '}
                  </option>
                  {zones.map((zone) => (
                    <option key={zone.id} value={zone.id}>
                      {zone.label || zone.name}
                    </option>
                  ))}
                </select>
                {errors.level1 && (
                  <p style={{ color: 'red' }}>{errors.level1.message}</p>
                )}
              </FormField>
              <FormField>
                <span>* Level 2 Name:</span>
                <input
                  name="name"
                  ref={register}
                  type="text"
                  placeholder="Name"
                />
                {errors.name && (
                  <p style={{ color: 'red' }}>{errors.name.message}</p>
                )}
              </FormField>
              <Form.Group widths="equal">
                <FormField>
                  <span>* Latitude:</span>
                  <input
                    name="Latitude"
                    ref={register}
                    type="number"
                    step="any"
                    placeholder="Latitude"
                  />
                  {errors.Latitude && (
                    <p style={{ color: 'red' }}>{errors.Latitude.message}</p>
                  )}
                </FormField>
                <FormField>
                  <span>* Longitude:</span>
                  <input
                    name="Longitude"
                    ref={register}
                    step="any"
                    type="number"
                    placeholder="Longitude"
                  />
                  {errors.Longitude && (
                    <p style={{ color: 'red' }}>{errors.Longitude.message}</p>
                  )}
                </FormField>
              </Form.Group>

              <Button
                from="cold"
                type="submit"
                style={{ backgroundColor: primaryColor, color: 'white' }}
              >
                Submit
              </Button>
            </Form>
          ) : null}
          {product !== 'cold' ? (
            <Form
              style={{
                padding: 10,
                borderRadius: 9,
              }}
              onSubmit={handleSubmit(addRegion)}
              id="tank"
            >
              <FormField>
                <span>* Level 1 (Top Level):</span>
                <select name="level1" ref={register}>
                  <option disabled selected>
                    {' '}
                  </option>
                  {zones.map((zone) => (
                    <option key={zone.id} value={zone.id}>
                      {zone.label || zone.name}
                    </option>
                  ))}
                </select>
                {errors.level1 && (
                  <p style={{ color: 'red' }}>{errors.level1.message}</p>
                )}
              </FormField>
              <FormField>
                <span>* Level 2 Name:</span>
                <input
                  name="name"
                  ref={register}
                  type="text"
                  placeholder="Name"
                />
                {errors.name && (
                  <p style={{ color: 'red' }}>{errors.name.message}</p>
                )}
              </FormField>

              <Button
                from="tank"
                type="submit"
                style={{ backgroundColor: primaryColor, color: 'white' }}
              >
                Submit
              </Button>
            </Form>
          ) : null}
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="black"
            onClick={() => {
              setOpen(false)
              setSelectedCustomer()
            }}
          >
            Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

AddRegionModal.propTypes = {
  open: Proptypes.bool,
  getOpenState: Proptypes.func,
}

export default AddRegionModal
